module.exports = "<label\n  class=\"ui-input-label form-label\"\n  for=\"{{ labelFor }}\"\n  ng-transclude>\n  {{ label | translate }}\n</label>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fino/ng1-input-label/src/inputLabel.html
// module id = 1517
// module chunks = 12